import auth from './modules/auth';
import housing from './modules/housing';

export default {
    auth,
    housing,
}